var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.95,
    height: 15.989,
    viewBox: "0 0 15.95 15.989",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contact_us",
    transform: "translate(-2.069 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33931",
    "data-name": "Path 33931",
    d: "M6.136,13.913c2.281,2.283,5.3,4.109,7.928,4.109a4.349,4.349,0,0,0,3.194-1.313l.171-.171a1.689,1.689,0,0,0,0-2.34l-1.6-1.6a1.687,1.687,0,0,0-2.339,0l-.57.571a1.126,1.126,0,0,1-.8.342,1.035,1.035,0,0,1-.8-.342L6.878,8.72a1.1,1.1,0,0,1,0-1.6l.57-.571A1.758,1.758,0,0,0,7.962,5.41a1.594,1.594,0,0,0-.456-1.141l-1.6-1.712A1.7,1.7,0,0,0,4.767,2.1a1.436,1.436,0,0,0-1.141.514l-.285.171c-1.312,1.313-1.6,3.2-.913,5.421a15.754,15.754,0,0,0,3.707,5.707Zm-2-10.329.171-.171a.493.493,0,0,1,.342-.171A.406.406,0,0,1,5,3.413l1.6,1.6a.493.493,0,0,1,.171.342.407.407,0,0,1-.171.342l-.57.571a2.207,2.207,0,0,0,0,3.2l4.449,4.451a2.287,2.287,0,0,0,1.6.685,2.071,2.071,0,0,0,1.6-.685l.57-.571a.487.487,0,0,1,.741,0l1.6,1.6a.6.6,0,0,1,0,.742l-.171.171c-2.167,2.226-6.445.228-9.525-2.8a13.391,13.391,0,0,1-3.422-5.25A4.176,4.176,0,0,1,4.14,3.584Z",
    transform: "translate(0 -0.032)",
    fill: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33932",
    "data-name": "Path 33932",
    d: "M17.679,8.357a3.36,3.36,0,0,1,3.393,3.393.679.679,0,1,0,1.357,0A4.721,4.721,0,0,0,17.679,7,.641.641,0,0,0,17,7.679.641.641,0,0,0,17.679,8.357Z",
    transform: "translate(-7.049 -2.36)",
    fill: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33933",
    "data-name": "Path 33933",
    d: "M17.879,3.357a6.661,6.661,0,0,1,6.65,6.65.679.679,0,1,0,1.357,0A8.022,8.022,0,0,0,17.879,2a.641.641,0,0,0-.679.679A.641.641,0,0,0,17.879,3.357Z",
    transform: "translate(-7.867)",
    fill: "#dfdfdf"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/contact_us.11377a78404129cf7f80f530bcbf307b.svg";
export { ForwardRef as ReactComponent };